<nav class="navbar navbar-default blue-bg">
    <div class="container container-fluid">
        <div class="navbar-header">
            <h1 class="navbar-brand">Dziękujemy za skorzystanie z elektronicznego formularza wniosku o wpis do rejestru pośredników kredytowych (wnioski RPKiP). Trwa systemowa weryfikacja prawidłowości wniosku.
            </h1>
        </div>
    </div>
</nav>

<h1 class="text-align-center flex-1">
    Dziękujemy, złożenie wniosku zostanie potwierdzone w kolejnej wiadomości email.<br/>
</h1>

<br/>
<div class="flex">
    <p-button label="Wybór wniosku" icon="pi pi-backward" iconPos="left" styleClass="ml" (click)="chooseForm()"></p-button>
</div>



